import * as Yup from "yup";

export class NewApplicationModal {
    static create = Yup.object().shape({
        applicationName: Yup.string().required("Application Name Is Required."),
        applicationDescription: Yup.string().required("Description Is Required."),
        applicationLanguage: Yup.string().required("Select a language"),
        applicationFramework: Yup.string().required("Select a framework"),
        applicationCloudProvider: Yup.string().required("Select a Cloud provider"),
        applicationCloudCompute: Yup.string().required("Select a Cloud Compute Type"),
        applicationDatabase: Yup.string().required("Select a Database"),
        applicationArchitecture: Yup.string().required("Select an Architecture"),
    });
}
